import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import CategoryPage from "./Pages/Category/CategoryPage";
import SpecialPage from "./Pages/Special/SpecialPage";
import ProductPage from "./Pages/Product/ProductPage";
import EmployPage from "./Pages/Employ/EmployPage";
import UserPage from "./Pages/User/UserPage";
import OrderPage from "./Pages/Order/OrderPage";
import InventoryPage from "./Pages/Inventory/InventoryPage";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useEffect, useState } from "react";
import FlowerPage from "./Pages/Flower/FlowerPage";
import Login from "./Pages/Login/Login";

function App() {
  const [DarkMode, setDarkMode] = useState(false);
  // const [changing, setChanging] = useState(false);

  // useEffect(() => {
  //   if (changing) {
  //     const theme = window.localStorage.getItem('tsetsegtuvtheme');
  //     setDarkMode(theme);
  //     setChanging(false);
  //   }
  // }, [changing])

  const theme = createTheme({
    palette: {
      mode: DarkMode ? "dark" : "light",
      background: {
        default: DarkMode ? "#121212" : "#ffffff",
      },
      text: {
        primary: DarkMode ? "#ffffff" : "#000000",
        secondary: DarkMode ? "#b0b0b0" : "#555555",
      },
    },
  });

  const changeTheme = () => {
    setDarkMode(!DarkMode);
    // window.localStorage.setItem('tsetsegtuvtheme', DarkMode.toString());
    // setChanging(true);
  }

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <div
          className={
            DarkMode
              ? "flex min-h-screen text-gray-100 overflow-auto bg-gray-800"
              : "flex min-h-screen text-gray-100 overflow-auto bg-gray-100"
          }
        >
          <Routes>
            <Route path="/" element={<Sidebar check={DarkMode} />}>
              <Route path="/category" element={<CategoryPage check={DarkMode} change={changeTheme} />} />
              <Route path="/special" element={<SpecialPage check={DarkMode} change={changeTheme} />} />
              <Route path="/product" element={<ProductPage check={DarkMode} change={changeTheme} />} />
              <Route path="/employ" element={<EmployPage check={DarkMode} change={changeTheme} />} />
              <Route path="/users" element={<UserPage check={DarkMode} change={changeTheme} />} />
              <Route path="/orders" element={<OrderPage check={DarkMode} change={changeTheme} />} />
              <Route path="/inventory" element={<InventoryPage check={DarkMode} change={changeTheme} />} />
              <Route path="/flower" element={<FlowerPage check={DarkMode} change={changeTheme} />} />
            </Route>
            <Route path="/login" element={<Login check={DarkMode} />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
